import { Component, OnDestroy, OnInit } from "@angular/core";
import { DataService } from "../../../_services/data.service";
import { AuthenticationService } from "../../../_services/authentication.service";
import { EventsService } from "../../../_services/eventsServices/events.service";
import { BehaviorSubject } from "rxjs/BehaviorSubject";

import { Router } from "@angular/router";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { sleep } from "../../../_helpers/sleep";
import { ParentEventFromSearch } from "../../events-screen/event-page-models/parent-event-from-search";
import { GenericModalComponent } from "../../../form/generic-app-modal/generic-modal.component";
import { Observable } from "rxjs/Observable";
import { ITranslations } from "../../../_models/ITranslations";
import { TranslationService } from "../../../_services/translation.service";
import { SessionManagerService } from "../../../_services/SessionManager/session-manager.service";
import {
  UserManagementService,
  UsersTableSearchState,
} from "../../../_services/user-management.service";
import { GeneralRowEvent } from "../../../_models/general-row-event";
import { GenericCheckBoxStatus } from "../../../common/generic-check-box-with-minus/generic-checkbox-with-minus.component";
import { UserManagementUploadUsersExcelModalComponent } from "../user-management-upload-users-excel-modal/user-management-upload-users-excel-modal.component";
import { UserManagementFormMainModalContainerComponent } from "../user-management-form-main-modal-container/user-management-form-main-modal-container.component";
import { AppUserModel } from "../user-management-models/app-user.model";
import { UserEditPermissionLevel } from "../user-management-models/user-privilege-edit-type.enum";
import { PopoverService } from "../../../_services/popover.service";
import { ApprovalModalComponent } from "../../../common/approval-modal/approval-modal.component";
import { PasswordResetService } from "../../../_services/password-reset.service";

@Component({
  selector: "user-management-page",
  templateUrl: "./user-management-page.component.html",
  styleUrls: [
    "./user-management-page.component.scss",
    "../../events-screen/parent-events-page/parent-events-page.component.scss",
  ],
})
export class UserManagementPageComponent implements OnInit, OnDestroy {
  public readonly UPLOAD_USERS_EXCEL_FILE_ACTIVE = false;
  public readonly DOWNLOAD_USERS_EXCEL_FILE_ACTIVE = false;

  public GenericCheckBoxStatus = GenericCheckBoxStatus;
  public selectionStatus: GenericCheckBoxStatus =
    GenericCheckBoxStatus.NoneSelected;
  public selectedUsersIds: string[] = [];
  public translations$: Observable<ITranslations>;
  public readonly $userTable: BehaviorSubject<AppUserModel[]> =
    new BehaviorSubject<AppUserModel[]>([]);
  public readonly $openUserView: BehaviorSubject<string> =
    new BehaviorSubject<string>("");
  public readonly $usersTableSearchState: BehaviorSubject<UsersTableSearchState> =
    new BehaviorSubject<UsersTableSearchState>(null);
  public readonly $openDeleteModal: BehaviorSubject<
    ParentEventFromSearch | false
  > = new BehaviorSubject<ParentEventFromSearch | false>(false);
  public scrollCallback: ($event: any) => void;
  public hideTooltip: boolean = false;

  constructor(
    private userManagementService: UserManagementService,
    private eventsService: EventsService,
    private modalService: NgbModal,
    private router: Router,
    private dataService: DataService,
    private authenticationService: AuthenticationService,
    private translationService: TranslationService,
    private popoverService: PopoverService,
    private passwordResetService: PasswordResetService,
    private sessionManagerService: SessionManagerService
  ) {
    this.getUsers();
    this.translations$ = this.translationService.translations;

    this.scrollCallback = this.scrollCallbackHandler.bind(this);
  }

  public get isDevelopmentMode() {
    return this.sessionManagerService.isDevModeActive();
  }

  public toastMessage(message: string) {
    this.popoverService.popMessage(message);
  }

  public ngOnInit(): void {}

  public ngOnDestroy(): void {}

  public async setMultipleUserActivity(
    action: "setActive" | "setInActive",
    userIds: string[]
  ) {
    const result = await this.userManagementService.markUsersAsActiveOrInactive(
      userIds,
      action === "setActive" ? "active" : "inactive"
    );
    if (result.success) {
      if (userIds.length === 1) {
        this.toastMessage(`סטטוס עודכן בהצלחה!`);
      }
      this.toastMessage(`${userIds.length} משתמשים  עודכנו בהצלחה! `);
      this.userManagementService.tryToUpdateUsersStatusInSearch(
        userIds,
        action === "setActive" ? "active" : "inactive"
      );
    }
  }

  public async rowEventHandler($event: GeneralRowEvent<AppUserModel>) {
    const userId = $event.eventId;
    switch ($event.action) {
      case "setActive":
        this.setMultipleUserActivity("setActive", [userId]).then();
        break;
      case "setInActive":
        this.setMultipleUserActivity("setInActive", [userId]).then();
        break;
      case "select":
        this.selectedUsersIds.push(userId);
        this.updateSelectionStatus();
        break;
      case "unselect":
        this.selectedUsersIds = this.selectedUsersIds.filter(
          (id) => id !== userId
        );
        this.updateSelectionStatus();
        break;
      case "open":
        this.$openUserView.next(userId);
        break;
      case "close":
        this.$openUserView.next("");
        break;
      case "delete":
        break;

      case "edit":
        this.editUserFromSearchResults($event, "user");
        break;
      case "resetPassword":
        const appUser = $event.eventObject;
        const actionResult = await this.resetSinglePassword(appUser);
        if (actionResult.success) {
          const passwordResetSent =
            this.translationService.currentTranslations
              .admin_reset_password_send_to_success;
          this.toastMessage(
            ` ${passwordResetSent} ${appUser.firstName} ${appUser.lastName}`
          );
        }

        break;
      case "editActivityFields":
        this.editUserFromSearchResults($event, "activityFields");
        break;
    }
  }

  public async resetSinglePassword(user: AppUserModel) {
    return await this.passwordResetService.resetPasswordForSingleUser(user);
  }

  public editUserFromSearchResults(
    appUser: GeneralRowEvent<AppUserModel>,
    typeOfEdit: "user" | "activityFields"
  ) {
    const options = {
      ...UserManagementFormMainModalContainerComponent.modalOptions,
    };
    if (typeOfEdit === "activityFields") {
      options.windowClass = "edit-user-activities-window-class";
    }
    const modalRefEdit: NgbModalRef = this.modalService.open(
      UserManagementFormMainModalContainerComponent,
      options
    );
    (
      modalRefEdit.componentInstance as UserManagementFormMainModalContainerComponent
    ).modalEventIdInput = appUser.eventId;
    (
      modalRefEdit.componentInstance as UserManagementFormMainModalContainerComponent
    ).customEventType = typeOfEdit;
  }

  public modalResultHandler($event: any) {
    if ($event) {
      const parentEvent = this.$userTable.value.find(
        (fe) => fe.id === $event.parentEventCode
      );
    }
  }

  public scrollCallbackHandler($event: any) {
    this.userManagementService.scrolledToBottomOfResults().then();
  }

  public addNewUser() {
    const modalRef: NgbModalRef = this.modalService.open(
      UserManagementFormMainModalContainerComponent,
      UserManagementFormMainModalContainerComponent.modalOptions
    );
    (
      modalRef.componentInstance as UserManagementFormMainModalContainerComponent
    ).modalEventIdInput = "new";
    (
      modalRef.componentInstance as UserManagementFormMainModalContainerComponent
    ).customEventType = "user";
  }

  public changeCheckboxStatusHandler($event: GenericCheckBoxStatus) {
    switch ($event) {
      case GenericCheckBoxStatus.NoneSelected:
        this.selectionStatus = GenericCheckBoxStatus.NoneSelected;
        this.selectedUsersIds = [];
        break;
      case GenericCheckBoxStatus.AllSelected:
        this.selectionStatus = GenericCheckBoxStatus.AllSelected;
        this.selectedUsersIds = this.$userTable.value
          .filter(
            (u) =>
              u.canEditPermissionLevel ===
              UserEditPermissionLevel.EditPermissions
          )
          .map((u) => u.id);
        break;
      case GenericCheckBoxStatus.SomeSelected:
        this.selectionStatus = GenericCheckBoxStatus.SomeSelected;
        break;
    }
  }

  public showFeatureNotImplementedModal() {
    const modalRef: NgbModalRef = this.modalService.open(
      ApprovalModalComponent
    );
    modalRef.componentInstance.info = {
      mainMessage:
        this.translationService.currentTranslations
          .feature_not_implemented_text,
      approveText:
        this.translationService.currentTranslations
          .payment_return_action_type_APPROVE,
      modalHeader:
        this.translationService.currentTranslations
          .feature_not_implemented_header,
      hideCancelButton: true,
    };
  }

  public openUploadUsersExcelFileModal() {
    if (!this.UPLOAD_USERS_EXCEL_FILE_ACTIVE) {
      this.showFeatureNotImplementedModal();
      return;
    }
    const modalRefEdit: NgbModalRef = this.modalService.open(
      UserManagementUploadUsersExcelModalComponent,
      UserManagementUploadUsersExcelModalComponent.modalOptions
    );
  }

  public handleSearchSectionEvent($event: GeneralRowEvent<AppUserModel>) {
    this.editUserFromSearchResults(
      $event,
      $event.action === "edit" ? "user" : "activityFields"
    );
  }

  public actionTableButton(
    $event: MouseEvent,
    action: "excel" | "resetPassword" | "makeActive" | "makeInactive"
  ) {
    let text = `${this.selectedUsersIds.length} ` + `משתמשים נבחרו.`;
    let modalHeader = "";
    switch (action) {
      case "excel":
        if (!this.DOWNLOAD_USERS_EXCEL_FILE_ACTIVE) {
          this.showFeatureNotImplementedModal();
          return;
        }
        break;
      case "resetPassword":
        text += ` האם לאפס את הסיסמה למשתמשים הנבחרים ?`;
        modalHeader = "איפוס סיסמה";
        break;
      case "makeActive":
        text += ` האם להפוך את המשתמשים הנבחרים לפעילים ?`;
        modalHeader = "הפוך לפעיל";
        break;
      case "makeInactive":
        text += ` האם להפוך את המשתמשים הנבחרים ללא פעילים ?`;
        modalHeader = "הפוך ללא פעיל";
        break;
    }
    this.hideTooltip = true;
    const modalRef: NgbModalRef = this.modalService.open(GenericModalComponent);

    modalRef.componentInstance.modalOptions = {
      modalHeader,
      modalText: text,
      onlyApprove: false,
    };
    modalRef.result.then((res) => {
      this.hideTooltip = false;
      if (res === "approve") {
        switch (action) {
          case "resetPassword":
            // reset password add notification
            break;
          case "makeActive":
            this.setMultipleUserActivity(
              "setActive",
              this.selectedUsersIds
            ).then(() => {
              this.selectedUsersIds = [];
              this.updateSelectionStatus();
            });
            break;
          case "makeInactive":
            this.setMultipleUserActivity(
              "setInActive",
              this.selectedUsersIds
            ).then(() => {
              this.selectedUsersIds = [];
              this.updateSelectionStatus();
            });
            break;
        }
      }
    });
  }

  private updateSelectionStatus() {
    if (this.selectedUsersIds.length === 0) {
      this.selectionStatus = GenericCheckBoxStatus.NoneSelected;
      return;
    }
    if (
      this.selectedUsersIds.length ===
      this.$userTable.value.length -
        this.$userTable.value.filter(
          (u) =>
            u.canEditPermissionLevel === UserEditPermissionLevel.EditPermissions
        ).length
    ) {
      this.selectionStatus = GenericCheckBoxStatus.AllSelected;
      return;
    }
    this.selectionStatus = GenericCheckBoxStatus.SomeSelected;
  }

  private getUsers(): void {
    this.userManagementService
      .getAllUsersInTable()
      .subscribe((events: AppUserModel[]) => {
        this.$userTable.next(events);
        const allUserIds = new Set(events.map((e) => e.id));
        this.selectedUsersIds = this.selectedUsersIds.filter((id) =>
          allUserIds.has(id)
        );
        this.updateSelectionStatus();
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/users/user-management-page/user-management-page.component.ts